module.exports = "<app-nav></app-nav>\n<router-outlet></router-outlet>\n"